/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EmployeesReportColumn {
  employeeId = 'employeeId',
  employeeIdFromEmployer = 'employeeIdFromEmployer',
  employeeFirstName = 'employeeFirstName',
  employeeLastName = 'employeeLastName',
  employeeFullName = 'employeeFullName',
  email = 'email',
  dateOfBirth = 'dateOfBirth',
  employeeCustomClassCategory = 'employeeCustomClassCategory',
  employeeEligibleFrom = 'employeeEligibleFrom',
  employeeEligibleUntil = 'employeeEligibleUntil',
  employeeTerminationDate = 'employeeTerminationDate',
  employeeCreatedAt = 'employeeCreatedAt',
  employerId = 'employerId',
  subEntityName = 'subEntityName',
  subEntityName2 = 'subEntityName2',
  userId = 'userId',
  invitationStatus = 'invitationStatus',
  employeeRole = 'employeeRole',
  leaveOfAbsenceStartDate = 'leaveOfAbsenceStartDate',
  leaveOfAbsenceEndDate = 'leaveOfAbsenceEndDate',
  benefitEligibility = 'benefitEligibility',
  hasPreviousEligibility = 'hasPreviousEligibility',
  onboardingPeriodId = 'onboardingPeriodId',
  onboardingPeriodIdKey = 'onboardingPeriodIdKey',
  isSpecialEnrollment = 'isSpecialEnrollment',
  onboardingPeriodIsActive = 'onboardingPeriodIsActive',
  onboardingFrom = 'onboardingFrom',
  onboardingUntil = 'onboardingUntil',
  class = 'class',
  onboardingPeriodAllowance = 'onboardingPeriodAllowance',
  enrollmentSubmissionDate = 'enrollmentSubmissionDate',
  onboardingPeriodIsWaived = 'onboardingPeriodIsWaived',
  enrollmentType = 'enrollmentType',
  openEnrollmentPeriodId = 'openEnrollmentPeriodId',
  openEnrollmentEffectiveFrom = 'openEnrollmentEffectiveFrom',
  openEnrollmentEffectiveUntil = 'openEnrollmentEffectiveUntil',
  benefitId = 'benefitId',
  benefitType = 'benefitType',
  benefitFamilyUnit = 'benefitFamilyUnit',
  benefitStatus = 'benefitStatus',
  enrollmentEffectiveFrom = 'enrollmentEffectiveFrom',
  enrollmentEffectiveUntil = 'enrollmentEffectiveUntil',
  enrollmentSubmissionType = 'enrollmentSubmissionType',
  enrollmentStatus = 'enrollmentStatus',
  medicalPlanId = 'medicalPlanId',
  medicalPlanName = 'medicalPlanName',
  medicalCarrier = 'medicalCarrier',
  medicalPremium = 'medicalPremium',
  medicalEmployeeContribution = 'medicalEmployeeContribution',
  medicalEmployerContribution = 'medicalEmployerContribution',
  medicalSelfPayAmount = 'medicalSelfPayAmount',
  medicalIsHsaEligible = 'medicalIsHsaEligible',
  medicalIsCombinedPlan = 'medicalIsCombinedPlan',
  medicalPlanMarket = 'medicalPlanMarket',
  medicalSelfReportType = 'medicalSelfReportType',
  medicalSelfEnroll = 'medicalSelfEnroll',
  medicalPlanType = 'medicalPlanType',
  state = 'state',
  dependentCount = 'dependentCount',
  qleId = 'qleId',
  qleType = 'qleType',
  qleOtherReason = 'qleOtherReason',
  qleOccurredOn = 'qleOccurredOn',
  initialPremiumPaymentStatus = 'initialPremiumPaymentStatus',
  autoPayStatus = 'autoPayStatus',
  paymentMethodType = 'paymentMethodType',
  enrollmentTeamId = 'enrollmentTeamId',
  enrollmentTeamName = 'enrollmentTeamName',
  enrollmentAgentFirstName = 'enrollmentAgentFirstName',
  enrollmentAgentLastName = 'enrollmentAgentLastName',
  enrollmentAgentName = 'enrollmentAgentName',
  enrollmentAgentEmail = 'enrollmentAgentEmail',
  address = 'address',
  phone = 'phone',
  personalEmail = 'personalEmail',
  ssn = 'ssn',
  employmentType = 'employmentType',
  hireDate = 'hireDate',
  isOpenEnrollmentView = 'isOpenEnrollmentView',
  isLatestCoverageView = 'isLatestCoverageView',
  isEnrollmentsInProcessView = 'isEnrollmentsInProcessView',
  isAllView = 'isAllView',
}
